'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Airplane(_ref) {
  var size = _ref.size,
      color = _ref.color;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 16 16',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement('path', {
      d: 'M15.75.107a.558.558 0 0 1 .242.571l-2.286 13.707a.562.562 0 0 1-.285.401.548.548 0 0 1-.491.027l-4.705-1.918-2.66 2.918a.526.526 0 0 1-.42.187.509.509 0 0 1-.206-.036.536.536 0 0 1-.268-.21.574.574 0 0 1-.098-.325v-4.034L.36 9.673C.14 9.59.02 9.426.002 9.183a.52.52 0 0 1 .286-.527L15.144.089a.518.518 0 0 1 .607.018zm-3.053 13.377L14.67 1.678 1.868 9.058l3 1.222 7.704-5.702-4.267 7.112 4.392 1.794z',
      fill: color,
      fillRule: 'evenodd'
    })
  );
}

Airplane.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

Airplane.defaultProps = {
  size: 16,
  color: '#000000'
};

exports.default = Airplane;